export const optionsPortePopulacional = [
  { label: '1 - Até 20 mil', value: 1 },
  { label: '2 - Acima de 20 mil até 50 mil', value: 2 },
  { label: '3 - Acima de 50 mil até 100 mil', value: 3 },
  { label: '4 - Acima de 100 mil', value: 4 },
]

export const optionsIed = [
  { label: '1', value: 1 },
  { label: '2', value: 2 },
  { label: '3', value: 3 },
  { label: '4', value: 4 },
]

export const regras = {
  fixo: {
    implantacao: {
      esf: 30000,
      eap_30h: 16800,
      eap_20h: 10800,
      esb_40h: 14000,
      emulti_ampliada: 36000,
      emulti_complementar: 24000,
      emulti_estrategica: 12000,
    },
    custeio: [
      {
        ied: 1,
        tipos_equipes: [
          {
            tipo: 'esf',
            label: 'eSF 40h',
            valor: 18000,
          },
          {
            tipo: 'eap_30h',
            label: 'eAP 30h',
            valor: 10800,
          },
          {
            tipo: 'eap_20h',
            label: 'eAP 20h',
            valor: 7200,
          },
        ],
      },
      {
        ied: 2,
        tipos_equipes: [
          {
            tipo: 'esf',
            label: 'eSF 40h',
            valor: 16000,
          },
          {
            tipo: 'eap_30h',
            label: 'eAP 30h',
            valor: 9600,
          },
          {
            tipo: 'eap_20h',
            label: 'eAP 20h',
            valor: 6400,
          },
        ],
      },
      {
        ied: 3,
        tipos_equipes: [
          {
            tipo: 'esf',
            label: 'eSF 40h',
            valor: 14000,
          },
          {
            tipo: 'eap_30h',
            label: 'eAP 30h',
            valor: 8400,
          },
          {
            tipo: 'eap_20h',
            label: 'eAP 20h',
            valor: 5600,
          },
        ],
      },
      {
        ied: 4,
        tipos_equipes: [
          {
            tipo: 'esf',
            label: 'eSF 40h',
            valor: 12000,
          },
          {
            tipo: 'eap_30h',
            label: 'eAP 30h',
            valor: 7200,
          },
          {
            tipo: 'eap_20h',
            label: 'eAP 20h',
            valor: 4800,
          },
        ],
      },
    ],
  },
  vinculo_e_acompanhamento: [
    {
      equipe: 'esf',
      label: 'eSF 40h',
      modalidade: '40h',
      classificacao: [
        {
          tipo: 'Ótimo',
          valor: 8000,
        },
        {
          tipo: 'Bom',
          valor: 6000,
        },
        {
          tipo: 'Suficiente',
          valor: 4000,
        },
        {
          tipo: 'Regular',
          valor: 2000,
        },
      ],
    },
    {
      equipe: 'eap_30h',
      label: 'eAP 30h',
      modalidade: '30h',
      classificacao: [
        {
          tipo: 'Ótimo',
          valor: 4000,
        },
        {
          tipo: 'Bom',
          valor: 3000,
        },
        {
          tipo: 'Suficiente',
          valor: 2000,
        },
        {
          tipo: 'Regular',
          valor: 1000,
        },
      ],
    },
    {
      equipe: 'eap_20h',
      label: 'eAP 20h',
      modalidade: '20h',
      classificacao: [
        {
          tipo: 'Ótimo',
          valor: 3000,
        },
        {
          tipo: 'Bom',
          valor: 2250,
        },
        {
          tipo: 'Suficiente',
          valor: 1500,
        },
        {
          tipo: 'Regular',
          valor: 750,
        },
      ],
    },
  ],
  qualidade: [
    {
      equipe: 'esf',
      label: 'eSF 40h',
      modalidade: '40h',
      classificacao: [
        {
          tipo: 'Ótimo',
          valor: 8000,
        },
        {
          tipo: 'Bom',
          valor: 6000,
        },
        {
          tipo: 'Suficiente',
          valor: 4000,
        },
        {
          tipo: 'Regular',
          valor: 2000,
        },
      ],
    },
    {
      equipe: 'eap_30h',
      label: 'eAP 30h',
      modalidade: '30h',
      classificacao: [
        {
          tipo: 'Ótimo',
          valor: 4000,
        },
        {
          tipo: 'Bom',
          valor: 3000,
        },
        {
          tipo: 'Suficiente',
          valor: 2000,
        },
        {
          tipo: 'Regular',
          valor: 1000,
        },
      ],
    },
    {
      equipe: 'eap_20h',
      label: 'eAP 20h',
      modalidade: '20h',
      classificacao: [
        {
          tipo: 'Ótimo',
          valor: 3000,
        },
        {
          tipo: 'Bom',
          valor: 2250,
        },
        {
          tipo: 'Suficiente',
          valor: 1500,
        },
        {
          tipo: 'Regular',
          valor: 750,
        },
      ],
    },
    {
      equipe: 'emulti_ampliada',
      label: 'eMulti Ampliada',
      modalidade: 'Ampliada',
      classificacao: [
        {
          tipo: 'Ótimo',
          valor: 9000,
        },
        {
          tipo: 'Bom',
          valor: 6750,
        },
        {
          tipo: 'Suficiente',
          valor: 4500,
        },
        {
          tipo: 'Regular',
          valor: 2250,
        },
      ],
    },
    {
      equipe: 'emulti_complementar',
      label: 'eMulti Complementar',
      modalidade: 'Complementar',
      classificacao: [
        {
          tipo: 'Ótimo',
          valor: 6000,
        },
        {
          tipo: 'Bom',
          valor: 4500,
        },
        {
          tipo: 'Suficiente',
          valor: 3000,
        },
        {
          tipo: 'Regular',
          valor: 1500,
        },
      ],
    },
    {
      equipe: 'emulti_estrategica',
      label: 'eMulti Estratégica',
      modalidade: 'Estratégica',
      classificacao: [
        {
          tipo: 'Ótimo',
          valor: 3000,
        },
        {
          tipo: 'Bom',
          valor: 2250,
        },
        {
          tipo: 'Suficiente',
          valor: 1500,
        },
        {
          tipo: 'Regular',
          valor: 750,
        },
      ],
    },
    {
      equipe: 'esb_i_comum',
      label: 'eSB I - Comum',
      modalidade: 'I - Comum',
      classificacao: [
        {
          tipo: 'Ótimo',
          valor: 2449,
        },
        {
          tipo: 'Bom',
          valor: 1836.75,
        },
        {
          tipo: 'Suficiente',
          valor: 1224.5,
        },
        {
          tipo: 'Regular',
          valor: 612.25,
        },
      ],
    },
    {
      equipe: 'esb_ii_comum',
      label: 'eSB II - Comum',
      modalidade: 'II - Comum',
      classificacao: [
        {
          tipo: 'Ótimo',
          valor: 3267,
        },
        {
          tipo: 'Bom',
          valor: 2450.25,
        },
        {
          tipo: 'Suficiente',
          valor: 1663.5,
        },
        {
          tipo: 'Regular',
          valor: 816.75,
        },
      ],
    },
    {
      equipe: 'esb_i_quil_assent',
      label: 'eSB I- Quil/Assent',
      modalidade: 'I - Quil/Assent',
      classificacao: [
        {
          tipo: 'Ótimo',
          valor: 3673.5,
        },
        {
          tipo: 'Bom',
          valor: 2755.13,
        },
        {
          tipo: 'Suficiente',
          valor: 1836.75,
        },
        {
          tipo: 'Regular',
          valor: 918.38,
        },
      ],
    },
    {
      equipe: 'esb_ii_quil_assent',
      label: 'eSB II- Quil/Assent',
      modalidade: 'II - Quil/Assent',
      classificacao: [
        {
          tipo: 'Ótimo',
          valor: 4900.5,
        },
        {
          tipo: 'Bom',
          valor: 3675.38,
        },
        {
          tipo: 'Suficiente',
          valor: 2450.25,
        },
        {
          tipo: 'Regular',
          valor: 1225.13,
        },
      ],
    },
    {
      label: 'eCR I',
      classificacao: [
        {
          tipo: 'Regular',
          valor: 3000,
        },
        {
          tipo: 'Suficiente',
          valor: 3750,
        },
        {
          tipo: 'Bom',
          valor: 4500,
        },
        {
          tipo: 'Ótimo',
          valor: 6000,
        },
      ],
    },
    {
      label: 'eCR II',
      classificacao: [
        {
          tipo: 'Regular',
          valor: 4000,
        },
        {
          tipo: 'Suficiente',
          valor: 5000,
        },
        {
          tipo: 'Bom',
          valor: 6000,
        },
        {
          tipo: 'Ótimo',
          valor: 8000,
        },
      ],
    },
    {
      label: 'eCR III',
      classificacao: [
        {
          tipo: 'Regular',
          valor: 5000,
        },
        {
          tipo: 'Suficiente',
          valor: 6250,
        },
        {
          tipo: 'Bom',
          valor: 7500,
        },
        {
          tipo: 'Ótimo',
          valor: 10000,
        },
      ],
    },
    {
      label: 'Essencial 20h',
      classificacao: [
        { tipo: 'Ótimo', valor: 5000 },
        { tipo: 'Bom', valor: 3750 },
        { tipo: 'Suficiente', valor: 2500 },
        { tipo: 'Regular', valor: 1250 },
      ],
    },
    {
      label: 'Essencial 30h',
      classificacao: [
        { tipo: 'Ótimo', valor: 7000 },
        { tipo: 'Bom', valor: 5250 },
        { tipo: 'Suficiente', valor: 3500 },
        { tipo: 'Regular', valor: 1750 },
      ],
    },
    {
      label: 'Ampliada 20h',
      classificacao: [
        { tipo: 'Ótimo', valor: 6000 },
        { tipo: 'Bom', valor: 4500 },
        { tipo: 'Suficiente', valor: 3000 },
        { tipo: 'Regular', valor: 1500 },
      ],
    },
    {
      label: 'Ampliada 30h',
      classificacao: [
        { tipo: 'Ótimo', valor: 8000 },
        { tipo: 'Bom', valor: 6000 },
        { tipo: 'Suficiente', valor: 4000 },
        { tipo: 'Regular', valor: 2000 },
      ],
    },
  ],
}

/**
 * Retorna o label padronizado utilizado nas regras.
 *
 * @param {String} label
 * @returns {String}
 */
export function getLabelRegra(label) {
  const aliases = {
    eSF: 'eSF 40h',

    Ampliada: 'eMulti Ampliada',
    Complementar: 'eMulti Complementar',
    Estratégica: 'eMulti Estratégica',

    'eSB I - Quil/Assent': 'eSB I- Quil/Assent',
    'eSB II - Quil/Assent': 'eSB II- Quil/Assent',
  }

  return aliases[label] || label
}

export const infoHtml = `<div id='write' class=''><h4 id='simulação'><strong><span>SIMULAÇÃO</span></strong></h4><hr /><p><span>A compreensão e gestão dos recursos do cofinanciamento federal da APS dependem:</span></p><ul><li><p><span>da leitura e interpretação da  Portaria nº 3493 de 10 de abril de 2024;</span></p></li><li><p><span>do portal FNS (Consulta detalhada de pagamento) disponível no </span><a href='https://consultafns.saude.gov.br/#/detalhada' target='_blank'><span>link</span></a><span>; </span></p></li><li><p><span>do portal e-GESTOR (Financiamento APS &gt;&gt; Pagamento APS 2022-atual) disponível no </span><a href='https://egestorab.saude.gov.br/gestaoaps/relFinanciamentoParcela.xhtml' target='_blank'><span>link</span></a><span>; e</span></p></li><li><p><span>de fazer as contas utilizando uma planilha produzida por você.</span></p></li></ul><p><span>Para simplificar essa compreensão, o eSUS Feedback conta com uma calculadora, conforme está apresentada no vídeo abaixo.</span></p><p><a href='https://www.youtube.com/watch?v=GDu7kP5_43I' target='_blank'><img src='${require('@/assets/images/simulacao.png')}' width="100%" /></a></p><p><span>A calculadora é simples de usar e gera um relatório fazendo-se as contas e permitindo a compreensão dos recursos do cofinanciamento federal na APS. Ela tem memória, então ao voltar novamente, você pode partir do ponto onde parou e continuar suas contas.</span></p><p><span>O video abaixo apresenta a forma mais completa de preencher os dados e interpretar as informações contidas no relatório.</span></p><p><a href='https://www.youtube.com/watch?v=DvmY3j-5wPY' target='_blank'><img src='${require('@/assets/images/simulacao.jpg')}' width="100%" /></a></p></div>`
